import React, { FC } from 'react';
import { Tabs } from 'udesk-ui';

interface TemplateProps {
    activeTabKey?: number;
    onChange?: (key: string) => void;
    qualityTasksTypes?: any[];
}

const Template: FC<TemplateProps> = (props) => {
    const { activeTabKey, onChange: propsOnChange, qualityTasksTypes } = props;

    return (
        <Tabs
            activeKey={`${activeTabKey}`}
            onChange={propsOnChange}
            className="appeal-checking-task-page-task-type-tabs"
            size="small"
        >
            {qualityTasksTypes?.map((item) => (
                <Tabs.TabPane tab={item.name} key={item.id} />
            ))}
        </Tabs>
    );
};

export default Template;
